//natives
import React from "react";

//components
import Table from "../../../../../../../util/Table/.mixins/Table";
import Error from "../../../../../../../util/error/.mixins/Error";

//css
import PedidosListaCss from './PedidosLista-css';
const useStyles = PedidosListaCss();

export default function PedidosLista(props) {
    const classes = useStyles();
    return (
        <div>
            {!props.state.isLoading && !props.state.isError &&
            <div style={{width:'420px',marginTop:0}}>
                <Table {...props} className={classes.root}/>
            </div>
            }
            {props.state.isError &&
            <div align="center">
                <Error text={props.state.error}/>
            </div>
            }

        </div>
    );

}